import moment from 'moment';

export const transform = ({
                              id,
                              duration,
                              startTime,
                              type,
                              category,
                              categoriesArr,
                              remarks,
                              location,
                              person_id,
                              hidden_person_id,
                              score,
                              quantity,
                              execution_level,
                              completed,
                              SSOSig,
                              EmpSig,
                              mobileCreated,
                              timestamp,
                              lastUpdateTime,
                              reportedBy,
                              isKPIMandatory,
                              isMobileUpload,
                              isKPI
                          }) => (
    {
        id: id,
        type: {
            id: type.id,
            name: type.name,
        },
        category: category || [],
        categoriesArr: categoriesArr || "",
        completed: completed,
        mobileCreated: mobileCreated,
        startTime: startTime, //moment(startTime || '00:00:00', 'HH:mm:ss').format('HH:mm:ss'),
        duration: duration,
        location: location,
        remarks: {
            general: (remarks.general && unescape(remarks.general)),
            followup: remarks.followup,
            type: remarks.type,
            employee: remarks.employee,
            isAus:remarks.isAus
        },
        person_id: person_id,
        hidden_person_id:hidden_person_id,
        evaluations: [],
        attachments: [],
        signatures: {
            SSOSig: SSOSig && `data:image/png;base64,${SSOSig}`,
            EmpSig: EmpSig && `data:image/png;base64,${EmpSig}`
        },
        execution_level: execution_level,
        score: parseInt(score),
        quantity: parseInt(quantity),
        timestamp: moment(timestamp),
        lastUpdateTime: moment(lastUpdateTime),
        reportedBy: reportedBy,
        kpiMandatory: isKPIMandatory,
        mobileUpload: isMobileUpload,
        isKPI: isKPI
    }
);

transform.reverse = (report) => ({
    id: report.id,
    hidden_person_id: report.hidden_person_id,
    person_id: report.person_id,
    remarks: {
        general: report.remarks.general,
        followup: report.remarks.followup,
        type: report.remarks.type,
        employee: report.remarks.employee        
    },
    timestampstr: moment(report.timestamp).locale('en').format('DD/MM/YYYY'),
    location: report.location,
    type: {
        id: report.type.id
    },
    category: report.category,
    duration: report.duration,
    startTime: report.startTime,
    execution_level: report.execution_level,
    score: report.score,
    quantity: parseInt(report.quantity),
    completed: report.completed,
    reportedBy: report.reportedBy
});